export type ApplicationType = 'APPLICATION' | 'GAME';

export enum ESyncScope {
  LOCAL = 'LOCAL',
  NETWORK = 'NETWORK',
}
